module.exports = __webpack_public_path__ + "img/1.5b9f2dcf.png";